import importer from "common/importer";

const getAllDonors = importer("Sagas/Donors/getAllDonors/main");
const getAllDonorsSuccess = importer("Sagas/Donors/getAllDonors/success");
const getAllDonorsFailure = importer("Sagas/Donors/getAllDonors/failure");

const getDonors = importer("Sagas/Donors/getDonors/main");
const getDonorsSuccess = importer("Sagas/Donors/getDonors/success");
const getDonorsFailure = importer("Sagas/Donors/getDonors/failure");

const getDonorBySfid = importer("Sagas/Donors/getDonorBySfid/main");
const getDonorBySfidSuccess = importer("Sagas/Donors/getDonorBySfid/success");
const getDonorBySfidFailure = importer("Sagas/Donors/getDonorBySfid/failure");

const searchForDonor = importer("Sagas/Donors/searchForDonor/main");
const searchForDonorSuccess = importer("Sagas/Donors/searchForDonor/success");
const searchForDonorFailure = importer("Sagas/Donors/searchForDonor/failure");

const searchActiveDonors = importer("Sagas/Donors/searchActiveDonors/main");
const searchActiveDonorsSuccess = importer(
  "Sagas/Donors/searchActiveDonors/success"
);
const searchActiveDonorsFailure = importer(
  "Sagas/Donors/searchActiveDonors/failure"
);

const registerDonor = importer("Sagas/Donors/registerDonor/main");
const registerDonorSuccess = importer("Sagas/Donors/registerDonor/success");
const registerDonorFailure = importer("Sagas/Donors/registerDonor/failure");

const registerGetDonorProfile = importer(
  "Sagas/Donors/registerGetDonorProfile/main"
);
const registerGetDonorProfileSuccess = importer(
  "Sagas/Donors/registerGetDonorProfile/success"
);
const registerGetDonorProfileFailure = importer(
  "Sagas/Donors/registerGetDonorProfile/failure"
);

const updateDonor = importer("Sagas/Donors/updateDonor/main");
const updateDonorSuccess = importer("Sagas/Donors/updateDonor/success");
const updateDonorFailure = importer("Sagas/Donors/updateDonor/failure");

const inquiryDonor = importer("Sagas/Donors/inquiryDonor/main");
const inquiryDonorSuccess = importer("Sagas/Donors/inquiryDonor/success");
const inquiryDonorFailure = importer("Sagas/Donors/inquiryDonor/failure");

const getDonorsPreferences = importer("Sagas/Donors/getDonorsPreferences/main");
const getDonorsPreferencesSuccess = importer(
  "Sagas/Donors/getDonorsPreferences/success"
);
const getDonorsPreferencesFailure = importer(
  "Sagas/Donors/getDonorsPreferences/failure"
);

const updateDonorsPreferences = importer(
  "Sagas/Donors/updateDonorsPreferences/main"
);
const updateDonorsPreferencesSuccess = importer(
  "Sagas/Donors/updateDonorsPreferences/success"
);
const updateDonorsPreferencesFailure = importer(
  "Sagas/Donors/updateDonorsPreferences/failure"
);

const getDonorLifetimeImpact = importer(
  "Sagas/Donors/getDonorLifetimeImpact/main"
);
const getDonorLifetimeImpactSuccess = importer(
  "Sagas/Donors/getDonorLifetimeImpact/success"
);
const getDonorLifetimeImpactFailure = importer(
  "Sagas/Donors/getDonorLifetimeImpact/failure"
);

const getDonorApcStatus = importer("Sagas/Donors/getDonorApcStatus/main");
const getDonorApcStatusSuccess = importer(
  "Sagas/Donors/getDonorApcStatus/success"
);
const getDonorApcStatusFailure = importer(
  "Sagas/Donors/getDonorApcStatus/failure"
);

const getDonorReferEarnedAmount = importer(
  "Sagas/Donors/getDonorReferEarnedAmount/main"
);
const getDonorReferEarnedAmountSuccess = importer(
  "Sagas/Donors/getDonorReferEarnedAmount/success"
);
const getDonorReferEarnedAmountFailure = importer(
  "Sagas/Donors/getDonorReferEarnedAmount/failure"
);

export default {
  getAllDonors,
  getAllDonorsSuccess,
  getAllDonorsFailure,

  getDonors,
  getDonorsSuccess,
  getDonorsFailure,

  getDonorBySfid,
  getDonorBySfidSuccess,
  getDonorBySfidFailure,

  searchForDonor,
  searchForDonorSuccess,
  searchForDonorFailure,

  searchActiveDonors,
  searchActiveDonorsSuccess,
  searchActiveDonorsFailure,

  registerDonor,
  registerDonorSuccess,
  registerDonorFailure,

  registerGetDonorProfile,
  registerGetDonorProfileSuccess,
  registerGetDonorProfileFailure,

  updateDonor,
  updateDonorSuccess,
  updateDonorFailure,

  inquiryDonor,
  inquiryDonorSuccess,
  inquiryDonorFailure,

  getDonorsPreferences,
  getDonorsPreferencesSuccess,
  getDonorsPreferencesFailure,

  updateDonorsPreferences,
  updateDonorsPreferencesSuccess,
  updateDonorsPreferencesFailure,

  getDonorLifetimeImpact,
  getDonorLifetimeImpactSuccess,
  getDonorLifetimeImpactFailure,

  getDonorApcStatus,
  getDonorApcStatusSuccess,
  getDonorApcStatusFailure,

  getDonorReferEarnedAmount,
  getDonorReferEarnedAmountSuccess,
  getDonorReferEarnedAmountFailure,
};
